/**
 * Created by razial on 15.04.2026.
 */

if (typeof RewardedPromoConditions === "undefined") {
    RewardedPromoConditions = {};
}

const RewardedPromoTracker = function () {
    this.crossId = undefined;
    this.promotion = undefined;
    this.pendingNotifications = [];

    this.load();

    connector.platform.parsePayload((data) => this.parsePayload(data));

    this.lookupByPlayer();
    connector.social.on("login", () => this.lookupByPlayer());
};

RewardedPromoTracker.prototype.load = function () {
    const syncedData = cleverapps.syncedStorage.load("promotaskstracker") || {};

    this.crossId = syncedData.crossId;
    this.loggedArrive = syncedData.loggedArrive || false;

    this.loadPromotion();
};

RewardedPromoTracker.prototype.save = function () {
    cleverapps.syncedStorage.save("promotaskstracker", {
        crossId: this.crossId,
        loggedArrive: this.loggedArrive || undefined
    });
};

RewardedPromoTracker.prototype.reset = function () {
    this.crossId = undefined;
    this.promotion = undefined;
    this.loggedArrive = false;
    this.save();
};

RewardedPromoTracker.prototype.parsePayload = function (data) {
    if (!data || !data.crossId || this.crossId === data.crossId) {
        return;
    }

    this.crossId = data.crossId;
    this.loggedArrive = false;
    this.save();

    this.loadPromotion();
};

RewardedPromoTracker.prototype.lookupByPlayer = function () {
    if (this.crossId || !connector.platform.hasPublisherPlayerId()) {
        return;
    }

    const config = RewardedPromoConfig.PROJECTS[cleverapps.config.name];
    const keys = (config && config.sources || []).map((sourceId) => RewardedPromotion.PlayerKey(sourceId, cleverapps.config.name));

    const next = () => {
        const crossId = keys.shift();
        if (!crossId || this.crossId) {
            return;
        }

        connector.multi.rewardedpromo.loadData(crossId, (error, data) => {
            if (!error && data && data.projectId === cleverapps.config.name) {
                this.parsePayload({ crossId });
                return;
            }

            next();
        });
    };

    next();
};

RewardedPromoTracker.prototype.loadPromotion = function () {
    if (!this.crossId) {
        return;
    }

    const crossId = this.crossId;

    connector.multi.rewardedpromo.loadData(crossId, (error, data) => {
        if (this.crossId !== crossId) {
            return;
        }

        if (error) {
            return;
        }

        if (!data || !data.projectId || !RewardedPromoConfig.PROJECTS[data.projectId]) {
            this.crossId = undefined;
            this.save();
            return;
        }

        this.promotion = new RewardedPromotion(crossId);
        this.promotion.updateData(data);
        this.logArrive();
        this.updateTasks();
    });
};

RewardedPromoTracker.prototype.isActive = function () {
    return this.promotion && this.promotion.isActive();
};

// itemId names the sending game on what this game logs for a promotion, so the dashboards can split it by sender
RewardedPromoTracker.prototype.logArrive = function () {
    if (this.loggedArrive || this.promotion.hostPayerTier === undefined) {
        return;
    }

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.CPROMO_ARRIVE}_${this.promotion.hostPayerTier}`, { itemId: this.promotion.sourceId });
    this.loggedArrive = true;
    this.save();
};

RewardedPromoTracker.prototype.onPurchase = function (purchase) {
    if (!this.isActive() || this.promotion.hostPayerTier === undefined) {
        return;
    }

    const price = purchase.realPrice;

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.CPROMO_PAY}_${this.promotion.hostPayerTier}_${cleverapps.paymentsHistory.classify()}`, { value: price, itemId: this.promotion.sourceId });

    const product = connector.payments.getProduct(purchase.productId);
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.CPROMO_PRODUCT}-${product ? product.itemId : purchase.productId}`, { value: price, itemId: this.promotion.sourceId });
};

RewardedPromoTracker.prototype.updateTasks = function () {
    if (!this.isActive()) {
        return;
    }

    const connecting = !this.promotion.isConnected();

    let changed = false;

    for (const task of this.promotion.tasks.slice(0, -1)) {
        if (task.isCompleted()) {
            continue;
        }

        const conditions = task.config.conditions || {};
        const completed = Object.keys(conditions).every((key) => {
            if (RewardedPromoConditions[key]) {
                return RewardedPromoConditions[key](conditions[key]);
            }
            return cleverapps.user.checkAvailable({ [key]: conditions[key] });
        });

        if (completed) {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.CPROMO_COMPLETED}-${this.promotion.projectId}-${task.config.bit}`, { itemId: this.promotion.sourceId });

            this.pendingNotifications.push(task);

            this.promotion.completed |= (1 << task.config.bit);
            task.onUpdate();
            changed = true;
        }
    }

    if (changed) {
        const update = { completed: this.promotion.completed };

        if (connecting) {
            this.promotion.started = Date.now();
            update.started = this.promotion.started;
        }

        connector.multi.rewardedpromo.updateData(this.crossId, update);
    }
};

RewardedPromoTracker.prototype.showNotifications = function () {
    if (!this.pendingNotifications.length) {
        return;
    }

    // the icon of the game the player came from, when the tracker has one
    const frames = bundles.notification.frames;
    const sourceId = this.promotion && this.promotion.sourceId;
    const image = frames[`rewardedpromo_tracker_${sourceId}`] || frames.rewardedpromo_notification_png;

    this.pendingNotifications.forEach((task) => {
        const title = task.getTitle().replace(/<\/?em>/g, "");
        cleverapps.notification.create(title, { image });
    });

    this.pendingNotifications = [];
};

RewardedPromoTracker.prototype.logTutorialFinish = function () {
    if (this.isActive()) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.CPROMO_TUTORIAL}-${this.promotion.projectId}`, { itemId: this.promotion.sourceId });
    }
};

cleverapps.InitByFeature["rewarded_promo_tracker"] = function () {
    cleverapps.rewardedPromoTracker = new RewardedPromoTracker();

    cleverapps.eventBus.on("userChanged", () => {
        cleverapps.rewardedPromoTracker.reset();
    });

    if (connector.payments) {
        connector.payments.on("purchase", (result) => {
            if (result && result.purchase) {
                cleverapps.rewardedPromoTracker.onPurchase(result.purchase);
            }
        });
    }
};

Placements.ENTRIES["updateRewardedPromo"] = {
    type: Placements.FREE_FOCUS_MAIN,

    action: function () {
        cleverapps.rewardedPromoTracker.updateTasks();
        cleverapps.rewardedPromoTracker.showNotifications();
    }
};
